// extracted by mini-css-extract-plugin
export default {"mobileMenuTabs":"MobileMenuTabs-mobileMenuTabs--059dc","activeTab":"MobileMenuTabs-activeTab--8a4d9"};